"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.__resetKevelVisibilityState__ = exports.unobserveKevelBanner = exports.observeKevelBanner = void 0;
const dispatchAnalytics_1 = require("./dispatchAnalytics");
const firedImpressions = new Set();
const pendingImpressions = new Map();
let sharedObserver = null;
let ensReadyListenerAttached = false;
const getImpressionKey = (eventData) => `${eventData.adId}`;
const dispatchVisibleImpression = (eventData) => {
    const key = getImpressionKey(eventData);
    if (firedImpressions.has(key)) {
        return;
    }
    (0, dispatchAnalytics_1.dispatchKevelAnalyticsEvent)(Object.assign({ action: "kevel.impression" }, eventData));
    firedImpressions.add(key);
};
const flushPendingImpressions = () => {
    const events = Array.from(pendingImpressions.values());
    pendingImpressions.clear();
    events.forEach(({ eventData }) => {
        dispatchVisibleImpression(eventData);
    });
};
const ensureEnsReadyListener = () => {
    if (ensReadyListenerAttached || !document.body) {
        return;
    }
    document.body.addEventListener("ensEventsReady", flushPendingImpressions, {
        once: true,
    });
    ensReadyListenerAttached = true;
};
const ensureObserver = () => {
    ensureEnsReadyListener();
    if (sharedObserver &&
        sharedObserver.constructor !== window.IntersectionObserver) {
        sharedObserver.disconnect();
        sharedObserver = null;
    }
    if (sharedObserver || !window.IntersectionObserver) {
        return sharedObserver;
    }
    sharedObserver = new window.IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            var _a;
            const target = entry.target;
            const eventData = target.__kevelEventData;
            if (!eventData) {
                return;
            }
            const key = getImpressionKey(eventData);
            if (!entry.isIntersecting || entry.intersectionRatio <= 0) {
                pendingImpressions.delete(key);
                return;
            }
            if ((_a = window.Bootstrapper) === null || _a === void 0 ? void 0 : _a.ensEventsReady) {
                dispatchVisibleImpression(eventData);
                sharedObserver === null || sharedObserver === void 0 ? void 0 : sharedObserver.unobserve(target);
                return;
            }
            pendingImpressions.set(key, { element: target, eventData });
        });
    });
    return sharedObserver;
};
const observeKevelBanner = (element, eventData) => {
    var _a;
    if (!element) {
        return;
    }
    const target = element;
    const key = getImpressionKey(eventData);
    if (firedImpressions.has(key)) {
        return;
    }
    target.__kevelEventData = eventData;
    const observer = ensureObserver();
    if (!observer) {
        if ((_a = window.Bootstrapper) === null || _a === void 0 ? void 0 : _a.ensEventsReady) {
            dispatchVisibleImpression(eventData);
        }
        return;
    }
    observer.observe(element);
};
exports.observeKevelBanner = observeKevelBanner;
const unobserveKevelBanner = (element, eventData) => {
    if (!element) {
        return;
    }
    const target = element;
    if (eventData) {
        pendingImpressions.delete(getImpressionKey(eventData));
    }
    delete target.__kevelEventData;
    sharedObserver === null || sharedObserver === void 0 ? void 0 : sharedObserver.unobserve(element);
};
exports.unobserveKevelBanner = unobserveKevelBanner;
// For testing purposes only - resets module state
const __resetKevelVisibilityState__ = () => {
    firedImpressions.clear();
    pendingImpressions.clear();
    if (sharedObserver) {
        sharedObserver.disconnect();
    }
    sharedObserver = null;
    ensReadyListenerAttached = false;
};
exports.__resetKevelVisibilityState__ = __resetKevelVisibilityState__;
